// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.QuickDetails_quick-heading__f8Hv-{
    font-size: 3.5vw;
    text-align: center;
    font-weight: 500;
}

.QuickDetails_images-container__zyJDH{
    width: 75vw;
    margin-left: 5vw;
    display: flex;
    flex-direction: row;
    margin-top: 5vw;
}

.QuickDetails_svg-container__n6nLV{
    width: 25vw;
    display: flex;
    flex-direction: column;
}

.QuickDetails_svg-text-heading__CqXvt{
    width:20vw;
    margin-left: 2.5vw;
    text-align: center;
    font-size: 2vw;
    font-weight: 500;
    margin-bottom: 0;
}

.QuickDetails_svg-text-desc__XzJrp{
    margin-top: 1vw;
    width:20vw;
    margin-left: 2.5vw;
    text-align: justify;
    font-size: 1.3vw;
    margin-bottom: 2vw;
}

.QuickDetails_inc-exclusion-container__C4xhj{
    width: 85vw;
    min-height: 5vw;
    height: auto;
    display: flex;
    flex-direction: row;
    padding-left: 5vw;
    padding-right: 5vw;
    box-sizing: border-box;
}

.QuickDetails_inclusion__GX2CC{
    width: 35vw;
    height: auto;
    display: flex;
    flex-direction: column;
    margin-bottom: 4vw;
}

.QuickDetails_inc-heading__tTJDU{
    text-align: center;
    font-size: 2vw;
    font-weight: 500;
}

.QuickDetails_inc-points__-HRt7{
    font-size: 1.3vw;
    /* font-weight: 200; */
    margin-bottom: 0.5vw;
    margin-top: 0;
    /* line-height: vw; */
}

.QuickDetails_exclusion__-b393{
    width: 35vw;
    margin-left: 5vw;
    height: auto;
    display: flex;
    flex-direction: column;
}

@media(max-width: 768px){

    .QuickDetails_quick-outer-container__ZESRH{
        border: 1px solid black;
        border-radius: 5vw;
        margin-bottom: 5vw;
    }

    .QuickDetails_quick-heading__f8Hv-{
        font-size: 6vw;
        text-align: center;
        font-weight: 500;
    }
    
    .QuickDetails_images-container__zyJDH{
        width: 90vw;
        margin-left: 0vw;
        display: flex;
        flex-direction: column;
        margin-top: 5vw;
    }
    
    .QuickDetails_svg-container__n6nLV{
        width: 90vw;
        display: flex;
        flex-direction: column;
        /* justify-content: center; */
        /* align-content: center; */
        align-items: center;
        /* justify-items: center; */
    }
    
    .QuickDetails_svg-text-heading__CqXvt{
        width:80vw;
        margin-left: 0vw;
        text-align: center;
        font-size: 6vw;
        font-weight: 350;
        margin-bottom: 0;
    }
    
    .QuickDetails_svg-text-desc__XzJrp{
        margin-top: 1vw;
        width:80vw;
        margin-left: 0vw;
        text-align: justify;
        font-size: 4vw;
        font-weight: 200;
        margin-bottom: 10vw;
    }
    
    .QuickDetails_inc-exclusion-container__C4xhj{
        width: 80vw;
        min-height: 5vw;
        height: auto;
        display: flex;
        flex-direction: column;
        padding-left: 5vw;
        padding-right: 5vw;
        box-sizing: border-box;
    }
    
    .QuickDetails_inclusion__GX2CC{
        width: 80vw;
        height: auto;
        display: flex;
        flex-direction: column;
        margin-bottom: 4vw;
    }
    
    .QuickDetails_inc-heading__tTJDU{
        text-align: center;
        font-size: 6vw;
        font-weight: 500;
        margin-bottom: 3vw;
    }
    
    .QuickDetails_inc-points__-HRt7{
        font-size: 4vw;
        font-weight: 200;
        margin-bottom: 0.5vw;
        margin-top: 0;
        line-height: 7vw;
    }
    
    .QuickDetails_exclusion__-b393{
        width: 80vw;
        margin-left: 0vw;
        height: auto;
        display: flex;
        flex-direction: column;
        margin-bottom: 8vw;
    }
}`, "",{"version":3,"sources":["webpack://./src/Pages/SingleTripPage/Tabs/QuickDetails/QuickDetails.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,oBAAoB;IACpB,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,sBAAsB;AAC1B;;AAEA;;IAEI;QACI,uBAAuB;QACvB,kBAAkB;QAClB,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,aAAa;QACb,sBAAsB;QACtB,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,sBAAsB;QACtB,6BAA6B;QAC7B,2BAA2B;QAC3B,mBAAmB;QACnB,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,gBAAgB;QAChB,kBAAkB;QAClB,cAAc;QACd,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,UAAU;QACV,gBAAgB;QAChB,mBAAmB;QACnB,cAAc;QACd,gBAAgB;QAChB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,YAAY;QACZ,aAAa;QACb,sBAAsB;QACtB,iBAAiB;QACjB,kBAAkB;QAClB,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,aAAa;QACb,sBAAsB;QACtB,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;QAClB,cAAc;QACd,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,gBAAgB;QAChB,oBAAoB;QACpB,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,gBAAgB;QAChB,YAAY;QACZ,aAAa;QACb,sBAAsB;QACtB,kBAAkB;IACtB;AACJ","sourcesContent":[".quick-heading{\n    font-size: 3.5vw;\n    text-align: center;\n    font-weight: 500;\n}\n\n.images-container{\n    width: 75vw;\n    margin-left: 5vw;\n    display: flex;\n    flex-direction: row;\n    margin-top: 5vw;\n}\n\n.svg-container{\n    width: 25vw;\n    display: flex;\n    flex-direction: column;\n}\n\n.svg-text-heading{\n    width:20vw;\n    margin-left: 2.5vw;\n    text-align: center;\n    font-size: 2vw;\n    font-weight: 500;\n    margin-bottom: 0;\n}\n\n.svg-text-desc{\n    margin-top: 1vw;\n    width:20vw;\n    margin-left: 2.5vw;\n    text-align: justify;\n    font-size: 1.3vw;\n    margin-bottom: 2vw;\n}\n\n.inc-exclusion-container{\n    width: 85vw;\n    min-height: 5vw;\n    height: auto;\n    display: flex;\n    flex-direction: row;\n    padding-left: 5vw;\n    padding-right: 5vw;\n    box-sizing: border-box;\n}\n\n.inclusion{\n    width: 35vw;\n    height: auto;\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 4vw;\n}\n\n.inc-heading{\n    text-align: center;\n    font-size: 2vw;\n    font-weight: 500;\n}\n\n.inc-points{\n    font-size: 1.3vw;\n    /* font-weight: 200; */\n    margin-bottom: 0.5vw;\n    margin-top: 0;\n    /* line-height: vw; */\n}\n\n.exclusion{\n    width: 35vw;\n    margin-left: 5vw;\n    height: auto;\n    display: flex;\n    flex-direction: column;\n}\n\n@media(max-width: 768px){\n\n    .quick-outer-container{\n        border: 1px solid black;\n        border-radius: 5vw;\n        margin-bottom: 5vw;\n    }\n\n    .quick-heading{\n        font-size: 6vw;\n        text-align: center;\n        font-weight: 500;\n    }\n    \n    .images-container{\n        width: 90vw;\n        margin-left: 0vw;\n        display: flex;\n        flex-direction: column;\n        margin-top: 5vw;\n    }\n    \n    .svg-container{\n        width: 90vw;\n        display: flex;\n        flex-direction: column;\n        /* justify-content: center; */\n        /* align-content: center; */\n        align-items: center;\n        /* justify-items: center; */\n    }\n    \n    .svg-text-heading{\n        width:80vw;\n        margin-left: 0vw;\n        text-align: center;\n        font-size: 6vw;\n        font-weight: 350;\n        margin-bottom: 0;\n    }\n    \n    .svg-text-desc{\n        margin-top: 1vw;\n        width:80vw;\n        margin-left: 0vw;\n        text-align: justify;\n        font-size: 4vw;\n        font-weight: 200;\n        margin-bottom: 10vw;\n    }\n    \n    .inc-exclusion-container{\n        width: 80vw;\n        min-height: 5vw;\n        height: auto;\n        display: flex;\n        flex-direction: column;\n        padding-left: 5vw;\n        padding-right: 5vw;\n        box-sizing: border-box;\n    }\n    \n    .inclusion{\n        width: 80vw;\n        height: auto;\n        display: flex;\n        flex-direction: column;\n        margin-bottom: 4vw;\n    }\n    \n    .inc-heading{\n        text-align: center;\n        font-size: 6vw;\n        font-weight: 500;\n        margin-bottom: 3vw;\n    }\n    \n    .inc-points{\n        font-size: 4vw;\n        font-weight: 200;\n        margin-bottom: 0.5vw;\n        margin-top: 0;\n        line-height: 7vw;\n    }\n    \n    .exclusion{\n        width: 80vw;\n        margin-left: 0vw;\n        height: auto;\n        display: flex;\n        flex-direction: column;\n        margin-bottom: 8vw;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"quick-heading": `QuickDetails_quick-heading__f8Hv-`,
	"images-container": `QuickDetails_images-container__zyJDH`,
	"svg-container": `QuickDetails_svg-container__n6nLV`,
	"svg-text-heading": `QuickDetails_svg-text-heading__CqXvt`,
	"svg-text-desc": `QuickDetails_svg-text-desc__XzJrp`,
	"inc-exclusion-container": `QuickDetails_inc-exclusion-container__C4xhj`,
	"inclusion": `QuickDetails_inclusion__GX2CC`,
	"inc-heading": `QuickDetails_inc-heading__tTJDU`,
	"inc-points": `QuickDetails_inc-points__-HRt7`,
	"exclusion": `QuickDetails_exclusion__-b393`,
	"quick-outer-container": `QuickDetails_quick-outer-container__ZESRH`
};
export default ___CSS_LOADER_EXPORT___;
